export var ZERO_WIDTH_CHAR = '\u200B';
export var ZERO_WIDTH_UNICODE_CHAR = `&#8203;`
export const UPDATE_DELAY = 100
